var _linearGradient, _linearGradient2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMorning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 398.515,
    y2: 106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffde00"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 406,
    y2: 376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe59a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffd5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 196c-74.443 0-135 60.557-135 135 0 23.73 6.255 47.065 18.076 67.515h233.848c11.821-20.45 18.076-43.785 18.076-67.515 0-74.443-60.557-135-135-135zm0-30c8.291 0 15-6.709 15-15v-30c0-8.291-6.709-15-15-15s-15 6.709-15 15v30c0 8.291 6.709 15 15 15zm-180 150h-30c-8.291 0-15 6.709-15 15s6.709 15 15 15h30c8.291 0 15-6.709 15-15s-6.709-15-15-15zm390 0h-30c-8.291 0-15 6.709-15 15s6.709 15 15 15h30c8.291 0 15-6.709 15-15s-6.709-15-15-15zm-15.146-97.5c-4.16-7.192-13.374-9.668-20.493-5.493l-25.972 15c-7.178 4.146-9.639 13.315-5.493 20.493 4.149 7.184 13.34 9.625 20.493 5.493l25.972-15c7.177-4.145 9.638-13.315 5.493-20.493zm-112.354-30.396c7.139 4.124 16.337 1.704 20.493-5.493l15-25.972c4.146-7.178 1.685-16.348-5.493-20.493-7.163-4.175-16.348-1.699-20.493 5.493l-15 25.972c-4.146 7.178-1.685 16.348 5.493 20.493zm-185.493-5.493c4.149 7.184 13.34 9.625 20.493 5.493 7.178-4.146 9.639-13.315 5.493-20.493l-15-25.972c-4.175-7.192-13.345-9.668-20.493-5.493-7.178 4.146-9.639 13.315-5.493 20.493zm-45.396 45.396-25.972-15c-7.178-4.175-16.333-1.699-20.493 5.493-4.146 7.178-1.685 16.348 5.493 20.493l25.972 15c7.139 4.124 16.337 1.704 20.493-5.493 4.146-7.178 1.685-16.348-5.493-20.493z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 376h-482c-8.291 0-15 6.709-15 15s6.709 15 15 15h482c8.291 0 15-6.709 15-15s-6.709-15-15-15z",
    fill: "url(#SVGID_2_)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorning);
export default __webpack_public_path__ + "static/media/morning.d1a1932165dbe1f5d060505d6d9e95f9.svg";
export { ForwardRef as ReactComponent };